import { registerNotification } from './registry'

registerNotification('review:created', {
  icon: () => 'question',
})